export class StartScreen {
  private root: HTMLDivElement;
  private hasStarted = false;

  constructor(
    private onStart: () => void | Promise<void>,
    private onClickSound?: () => void | Promise<void>,
  ) {
    this.root = document.createElement('div');
    this.root.style.position = 'fixed';
    this.root.style.inset = '0';
    this.root.style.display = 'flex';
    this.root.style.flexDirection = 'column';
    this.root.style.justifyContent = 'center';
    this.root.style.alignItems = 'center';
    this.root.style.background = 'radial-gradient(circle at center, #1e1e1e 0%, #050505 80%)';
    this.root.style.color = '#ffffff';
    this.root.style.fontFamily = '"Courier New", monospace';
    this.root.style.zIndex = '9999';
    this.root.style.cursor = 'pointer';
    this.root.style.transition = 'opacity 0.35s ease';
    this.root.style.opacity = '0';

    const title = document.createElement('h1');
    title.textContent = 'Mazing Hunters';
    title.style.fontSize = '48px';
    title.style.marginBottom = '20px';
    title.style.letterSpacing = '4px';
    this.root.appendChild(title);

    const subtitle = document.createElement('p');
    subtitle.textContent = 'Click anywhere to begin';
    subtitle.style.fontSize = '18px';
    subtitle.style.opacity = '0.8';
    this.root.appendChild(subtitle);

    document.body.appendChild(this.root);

    requestAnimationFrame(() => {
      this.root.style.opacity = '1';
    });

    this.root.addEventListener('click', () => {
      void this.start();
    });
    this.root.addEventListener('keyup', () => {
      void this.start();
    });
  }

  private async start(): Promise<void> {
    if (this.hasStarted) return;
    this.hasStarted = true;

    if (this.onClickSound) {
      try {
        await this.onClickSound();
      } catch (error) {
        console.warn('[StartScreen] Failed to play click sound:', error);
      }
    }

    this.root.style.opacity = '0';
    setTimeout(() => {
      this.destroy();
      Promise.resolve(this.onStart()).catch((error) => {
        console.error('[StartScreen] onStart failed:', error);
      });
    }, 300);
  }

  private destroy(): void {
    this.root.remove();
  }
}

